import React from "react";

import { Card, CardSkeleton } from "../index";
import { H3, } from "../../Typography";
import { CardGridContainer, Cards} from "./styles";

import {CardGridProps} from "./types";
import {CardProps} from "../types";
import { CARD_GRID_2, CARD_GRID_3, CARD_GRID_4 } from "@itchannelplus/utils";

const GRID_SIZES: Record<NonNullable<CardGridProps["cols"]>, string> = {
  2: CARD_GRID_2,
  3: CARD_GRID_3,
  4: CARD_GRID_4,
  5: "(max-width: 769px) 100vw, (max-width: 993px) 50vw, (max-width: 1201px) 33vw, (max-width: 1441px) 25vw, 20vw",
};

export const CardGrid = ({title, cards, cols = 4, align, ...props}: CardGridProps) => {
  const sizes = GRID_SIZES[cols];
  return (
    <CardGridContainer {...props}>
      {title && <H3 lineHeight={"medium"} >{title}</H3>}
      <Cards cols={cols} align={align}>
        { cards.map((card: CardProps, i) => <Card key={'card'+i} sizes={sizes} {...card} />) }
      </Cards>
    </CardGridContainer>
  );
}

export const CardGridSkeleton = ({imageRatio, cols = 4, align, ...props}: Pick<CardGridProps, 'cols'|'align'> & Required<Pick<CardProps, 'imageRatio'>>) => {
  return <CardGridContainer {...props}>
    <Cards cols={cols} align={align}>
      {new Array(cols).fill(0).map((_, i) => <CardSkeleton key={'card'+i} imageRatio={imageRatio} />)}
      {new Array(cols).fill(0).map((_, i) => <CardSkeleton key={'card'+i} imageRatio={imageRatio} />)}
    </Cards>
  </CardGridContainer>
}
